import { useAuthContext } from "../Hooks/UseAuthContext";
import { useState, useEffect } from "react";
import { message, Result, Divider, Descriptions, Tag, Alert, Steps, Badge, Table } from "antd";
import { Title, Text, Button, Card, Skeleton, Group } from "@mantine/core";
import dayjs from "dayjs";
import Companyprofiles from "../Pages/Forms/Companyprofiles";
import Complienceform from "../Pages/Forms/Complienceform";
import Bankdetailsform from "../Pages/Forms/Bankdetailsform";
import Merchantduedeligence from "../Pages/Forms/Merchantduedeligence";
import Boardofresolutionform from "../Pages/Forms/Board_of_resolutionform";
import Merchantcriminalundertaking from "../Pages/Forms/Merchantcriminalundertaking";
import Payoutcommercial from "../Pages/Commercials/Payoutcommercial";
import Uploaddocs from "../Pages/Forms/Uploadocs";
import Termsandconditions from "../Pages/Forms/Termsandconditions";






const Submission = () => {
    const { user } = useAuthContext();
    const [submissionDetails, setSubmissionDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const [selectedStep, setSelectedStep] = useState(null);

    const getUserData = async () => {
        const response = await fetch('https://api.boompay.in/get-final-submission-details', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${user}`,
            }
        });
        const data = await response.json();
        if (response.status === 200) {
            // console.log(data);
            setSubmissionDetails(data?.SubmissionDetails);
            setLoading(false);
        } else if (response.status === 401) {
            setLoading(false);
            // console.log('Unauthorized access. Please log in again.');
            message.error('Unauthorized access. Please log in again.');
        } else if (response.status === 404) {
            setLoading(false);
            //console.log('User not found.');
            message.error('Submisison details not found');
        } else {
            setLoading(false);
            //console.log('An error occurred while fetching user data.');
            message.error('An error occurred while fetching user data.');
        }
    }
    
    const renderRectificationComponent = () => {

        switch (selectedStep.step) {

            case 0:

                return (

                    <Companyprofiles
                        rectification={true}
                        stepData={selectedStep}
                        submissionDetails={submissionDetails}
                        onSuccess={() => {
                            setSelectedStep(null);
                            getUserData();
                        }}
                    />

                );

            case 1:

                return (

                    <Complienceform
                        rectification={true}
                        stepData={selectedStep}
                        submissionDetails={submissionDetails}
                        onSuccess={() => {
                            setSelectedStep(null);
                            getUserData();
                        }}
                    />

                );

            case 2:

                return (

                    <Bankdetailsform
                        rectification={true}
                        stepData={selectedStep}
                        submissionDetails={submissionDetails}
                        onSuccess={() => {
                            setSelectedStep(null);
                            getUserData();
                        }}
                    />

                );
            case 3:

                return (

                    <Merchantduedeligence
                        rectification={true}
                        stepData={selectedStep}
                        submissionDetails={submissionDetails}
                        onSuccess={() => {
                            setSelectedStep(null);
                            getUserData();
                        }}
                    />

                );

            case 4:

                return (

                    <Boardofresolutionform
                        rectification={true}
                        stepData={selectedStep}
                        submissionDetails={submissionDetails}
                        onSuccess={() => {
                            setSelectedStep(null);
                            getUserData();
                        }}
                    />

                );
            case 5:

                return (

                    <Merchantcriminalundertaking
                        rectification={true}
                        stepData={selectedStep}
                        submissionDetails={submissionDetails}
                        onSuccess={() => {
                            setSelectedStep(null);
                            getUserData();
                        }}
                    />

                );
            case 6:

                return (

                    <Payoutcommercial
                        rectification={true}
                        stepData={selectedStep}
                        submissionDetails={submissionDetails}
                        onSuccess={() => {
                            setSelectedStep(null);
                            getUserData();
                        }}
                    />

                );

            case 7:

                return (

                    <Uploaddocs
                        rectification={true}
                        stepData={selectedStep}
                        submissionDetails={submissionDetails}
                        onSuccess={() => {
                            setSelectedStep(null);
                            getUserData();
                        }}
                    />

                );
            case 8:

                return (

                    <Termsandconditions
                        rectification={true}
                        stepData={selectedStep}
                        submissionDetails={submissionDetails}
                        onSuccess={() => {
                            setSelectedStep(null);
                            getUserData();
                        }}
                    />

                );



            default:
                return null;
        }

    }


    useEffect(() => {
        const getUserData = async () => {
            const response = await fetch('https://api.boompay.in/get-final-submission-details', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                }
            });
            const data = await response.json();
            if (response.status === 200) {
                // console.log(data);
                setSubmissionDetails(data?.SubmissionDetails);
                setLoading(false);
            } else if (response.status === 401) {
                setLoading(false);
                // console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                setLoading(false);
                //console.log('User not found.');
                message.error('Submisison details not found');
            } else {
                setLoading(false);
                //console.log('An error occurred while fetching user data.');
                message.error('An error occurred while fetching user data.');
            }
        }

        if (user) {
            getUserData();
        }

    }, [user])

    return (
        <>

            <Skeleton visible={loading} height={400} width="100%">
                {submissionDetails?.onboarding_status === "Rectification Required" && (

                    <Alert
                        type="warning"
                        showIcon
                        title={`Rectification Required`}
                        description={
                            <>
                                Our verification team has requested changes in your onboarding.
                                Please review the sections below, make the required corrections,
                                and submit the onboarding again.
                            </>
                        }
                    />

                )}
                <Card
                    bordered
                    shadow="sm"
                    mt={'xs'}
                >
                    <Group justify="flex-end">
                        <Text size="xs" c={'dimmed'} fw={'bold'}>Last Updated on: {dayjs(submissionDetails?.updatedAt).format('DD MMM YYYY hh:mm A')}</Text>
                    </Group>
                    <Result

                        status={
                            submissionDetails?.onboarding_status === "Approved"
                                ? "success"
                                : submissionDetails?.onboarding_status === "Rejected"
                                    ? "error"
                                    : submissionDetails?.onboarding_status === "Rectification Required"
                                        ? "warning"
                                        : "info"
                        }

                        title={
                            `Submission ${submissionDetails?.onboarding_status}`
                        }

                        subTitle={`Your onboarding request has been submitted successfully.

                      Submission ID : ${submissionDetails?._id}`}
                    />

                    <Divider />

                    <Descriptions
                        bordered
                        column={1}
                        size="middle"
                    >

                        <Descriptions.Item label="Company Name">
                            {submissionDetails?.Registered_Name_of_Company}
                        </Descriptions.Item>

                        <Descriptions.Item label="GST Number">
                            {submissionDetails?.Registered_GST_Number}
                        </Descriptions.Item>

                        <Descriptions.Item label="PAN Number">
                            {submissionDetails?.Registered_PAN_Number}
                        </Descriptions.Item>

                        <Descriptions.Item label="Authorized Signatory">
                            {submissionDetails?.authorized_signatory_name}
                        </Descriptions.Item>

                        <Descriptions.Item label="Submission Date">
                            {dayjs(submissionDetails?.createdAt).format(
                                "DD MMM YYYY hh:mm A"
                            )}
                        </Descriptions.Item>

                        <Descriptions.Item label="Current Status">

                            <Badge
                                status={
                                    submissionDetails?.onboarding_status === "Approved"
                                        ? "success"
                                        : submissionDetails?.onboarding_status === "Rejected"
                                            ? "error"
                                            : submissionDetails?.onboarding_status === "Rectification Required"
                                                ? "warning"
                                                : "processing"
                                }
                                text={submissionDetails?.onboarding_status}
                            />

                        </Descriptions.Item>

                        <Descriptions.Item label="Current Verification Stage">

                            <Tag color="blue">

                                Stage {submissionDetails?.verification_step}

                            </Tag>

                        </Descriptions.Item>

                    </Descriptions>

                    <Divider />

                    <Title level={5}>

                        Verification Progress

                    </Title>

                    <Steps
                        direction="vertical"
                        current={
                            submissionDetails?.verification_step - 1
                        }
                        items={[
                            {
                                title: "AO Verification",
                                description:
                                    "Application Officer is verifying your submitted documents.",
                            },
                            {
                                title: "Onboarding Team Verification",
                                description:
                                    "Business verification and compliance review.",
                            },
                            {
                                title: "Legal Team Verification",
                                description:
                                    "Legal document validation.",
                            },
                            {
                                title: "Final Review & Approval",
                                description:
                                    "Final verification before activation.",
                            },
                        ]}
                    />

                    <Divider />

                    <Title level={5}>

                        Verification Remarks

                    </Title>

                    {

                        submissionDetails?.onboard_remark?.length > 0 ? (

                            <Descriptions
                                bordered
                                column={1}
                            >

                                <Descriptions.Item label="AO Remarks">

                                    {submissionDetails?.onboard_remark?.[0]?.ao_remarks || "-"}

                                </Descriptions.Item>

                                <Descriptions.Item label="Onboarding Team">

                                    {submissionDetails?.onboard_remark?.[0]?.onboardteam_remarks || "-"}

                                </Descriptions.Item>

                                <Descriptions.Item label="Legal Team">

                                    {submissionDetails?.onboard_remark?.[0]?.leagalteam_remarks || "-"}

                                </Descriptions.Item>

                                <Descriptions.Item label="Review Team">

                                    {submissionDetails?.onboard_remark?.[0]?.reviewteam_remarks || "-"}

                                </Descriptions.Item>

                            </Descriptions>

                        ) : (

                            <Alert
                                type="info"
                                showIcon
                                message="No remarks available."
                                description="Your onboarding request is under processing."
                            />

                        )

                    }
                    {
                        !selectedStep ? (

                            submissionDetails?.onboard_remark?.[0]?.rectification_steps?.length > 0 && (

                                <Card
                                    title="Required Corrections"
                                    style={{ marginTop: 20 }}
                                >

                                    <Table
                                        pagination={false}
                                        dataSource={submissionDetails.onboard_remark[0].rectification_steps}
                                        rowKey="_id"
                                    >

                                        <Table.Column
                                            title="Step"
                                            dataIndex="step_name"
                                        />

                                        <Table.Column
                                            title="Correction Required"
                                            dataIndex="remark"
                                        />

                                        <Table.Column
                                            title="Status"
                                            render={(row) => (

                                                <Tag
                                                    color={
                                                        row.status === "Completed"
                                                            ? "green"
                                                            : "orange"
                                                    }
                                                >
                                                    {row.status}
                                                </Tag>

                                            )}
                                        />

                                        <Table.Column
                                            title="Action"
                                            render={(item) => (

                                                <Button
                                                    variant="filled"
                                                    size="xs"
                                                    disabled={item.status === "Completed"}
                                                    onClick={() => setSelectedStep(item)}
                                                >

                                                    {
                                                        item.status === "Completed"
                                                            ? "Submitted"
                                                            : "Start Rectification"
                                                    }

                                                </Button>

                                            )}
                                        />

                                    </Table>

                                </Card>

                            )

                        ) : (

                            renderRectificationComponent()

                        )
                    }

                    <Divider />

                    <Alert
                        type="info"
                        showIcon
                        message="What's Next?"
                        description={
                            submissionDetails?.onboarding_status === "Pending"
                                ? "Your application has been received successfully. Our verification team will start reviewing your documents shortly."
                                : submissionDetails?.onboarding_status === "Under Review"
                                    ? "Your documents are currently being verified. Please wait until the review process is completed."
                                    : submissionDetails?.onboarding_status === "Rectification Required"
                                        ? "Some corrections are required. Please review the remarks above and submit the requested changes."
                                        : submissionDetails?.onboarding_status === "Approved"
                                            ? "Congratulations! Your onboarding has been approved. You can now download your onboarding documents and begin using our services."
                                            : "Your onboarding request has been rejected. Please contact the BOOM PAY onboarding team for further assistance."
                        }
                    />

                    {

                        submissionDetails?.onboarding_status ===
                        "Approved" && (

                            <Button
                                component="a"
                                href={`http://localhost:8000/download-onboarding-pdf/${submissionDetails?._id}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                variant="filled"
                                color="green"
                                mt="md"
                            >

                                Download Onboarding PDF

                            </Button>

                        )

                    }

                </Card>
            </Skeleton>
        </>
    )
}
export default Submission;